export const RECEIVED_TOKEN = "received_token";